import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PostExtendWarranty Input Action
 */
export class PostExtendWarrantyInput implements Msdyn365.IActionInput {
    public deviceId: string;
    constructor(deviceID: string) {
        this.deviceId = deviceID;
    }

    public getCacheKey = () => `PostExtendWarrantyKey`;
    public getCacheObjectType = () => 'PostExtendWarranty';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IPostExtendWarrantyData {
    Id: string;
    TicketNumber: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PostExtendWarrantyInput('');
};

async function action(input: PostExtendWarrantyInput, ctx: Msdyn365.IActionContext): Promise<IPostExtendWarrantyData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const requestBody = { deviceId: input.deviceId, language: ctx.requestContext.locale };

    const response = await Msdyn365.sendRequest<IPostExtendWarrantyData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/ExtendWarranty`,
        'post',
        requestBody,
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`,
                timeout: '30000'
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { ...response.data };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostExtendWarrantyData>>action,
    id: 'PostExtendWarranty',
    input: createInput
});
